module.exports = __webpack_public_path__ + "static/media/SEPLOGO.a7d90d0a.png";